import script from "./ErrorBoundary.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorBoundary.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__